import {UI_SORT, UI_TOGGLE} from "../actions/ui";

let uiInitialState = {
  toggle: {},
  sort: {}
};

let sortBackup = localStorage.getItem('ui_sort');
if (sortBackup) {
  try {
    uiInitialState['sort'] = JSON.parse(sortBackup);
  } catch(e) {
    console.error(e)
  }
}


export const uiReducer = (state = uiInitialState, action) => {
  switch (action.type) {
  case UI_TOGGLE: {
    return {
      ...state,
      'toggle': {
        ...state.toggle,
        [action.key]: !state.toggle[action.key]
      }
    };
  }
  case UI_SORT: {
    // ancien format possible (string) — converti à la volée pour rétro-compat localStorage
    const current = state.sort[action.colGroup];
    const currentKey = (current && typeof current === 'object') ? current.key : current;
    const currentDir = (current && typeof current === 'object') ? current.dir : 'asc';
    const nextDir = (currentKey === action.colKey)
      ? (currentDir === 'asc' ? 'desc' : 'asc')
      : 'asc';

    let newSort = {
      ...state.sort,
      [action.colGroup]: {key: action.colKey, dir: nextDir}
    };

    localStorage.setItem('ui_sort', JSON.stringify(newSort));

    return {
      ...state,
      'sort': newSort
    };
  }
  default: {
    return state;
  }
  }
};
